import { render, staticRenderFns } from "./AssistantInformationItem.vue?vue&type=template&id=7a098d1a&scoped=true"
import script from "./AssistantInformationItem.vue?vue&type=script&lang=js"
export * from "./AssistantInformationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a098d1a",
  null
  
)

export default component.exports